export enum SessionStorageEnums {
    LiveChatCached = 'loblivechatcached'
}
